"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (c) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...c,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 12c0-4.825 3.925-8.75 8.75-8.75s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75S3.25 16.825 3.25 12M2 12c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2 2 6.486 2 12m10-5.562a2.283 2.283 0 0 0-2.281 2.28A2.283 2.283 0 0 0 12 11a2.283 2.283 0 0 0 2.281-2.28A2.283 2.283 0 0 0 12 6.438m0 5.812a3.534 3.534 0 0 1-3.531-3.531A3.535 3.535 0 0 1 12 5.188a3.535 3.535 0 0 1 3.531 3.53A3.534 3.534 0 0 1 12 12.25m-2.442 1.922a2.326 2.326 0 0 0-2.323 2.323.91.91 0 0 0 .339.686c.96.75 2.509 1.645 4.427 1.647 1.917-.002 3.465-.896 4.426-1.647a.87.87 0 0 0 .332-.648l.012-.105c-.005-1.214-1.047-2.256-2.328-2.256zM12 20.078c-1.798-.001-3.595-.662-5.196-1.913a2.11 2.11 0 0 1-.81-1.575c-.01-2.065 1.593-3.668 3.564-3.668h4.885a3.577 3.577 0 0 1 3.573 3.573l-.013.139a2.08 2.08 0 0 1-.806 1.53c-1.601 1.252-3.398 1.913-5.197 1.914",
        clipRule: "evenodd"
      }
    )
  }
), r = l(e);
export {
  r as Account,
  r as default
};
